export enum DocumentServiceEnum {
  Internal,
  Klaviyo,
  Docusign,
}
